import {Component, OnDestroy, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromUser from '@app/core/user/store';
import * as fromFreezeBlock from '@app/root-store/ui/freeze-block';
import * as fromNewsletterForm from '@app/newsletter-new/store/newsletter-form/newsletter-form.actions';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import {first, Observable} from 'rxjs';
import {SubSink} from 'subsink';
import {NewsboardAuthService} from '@app/core/auth/services/newsboard-auth.service';
import { BLOCK_LIST, BlockTypes } from '@app/newsletter-new/models/block-type.enum';
import { selectHiddenBlocks } from '@app/root-store/ui/freeze-block';

@Component({
	selector: 'rh-freeze-block',
	templateUrl: './freeze-block.component.html',
	styleUrls: ['./freeze-block.component.scss'],
})
export class FreezeBlockComponent implements OnInit, OnDestroy {
	private subs: SubSink = new SubSink();

	private fromFreezeBlock$: Observable<boolean> = this.store$.pipe(select(fromFreezeBlock.selectBlockedEdition));
	private hasUserPermission$: Observable<boolean> = this.store$.pipe(
		select(fromFreezeBlock.selectUserHasWriteAccessPermission)
	);
	private sendingNewslettersOnBehalfOfUsers$: Observable<boolean> = this.store$.pipe(
		select(fromUser.selectSendingNewslettersOnBehalfOfUsers)
	);

	hiddenBlocks$: Observable<string[]> = this.store$.pipe(select(selectHiddenBlocks));
	hiddenBlocks = [];
	blockList = BLOCK_LIST;
	BlockTypes = BlockTypes;

	public form: FormGroup = new FormGroup({
		blocked: new FormControl(false, []),
		userHasWriteAccessPermission: new FormControl(false, []),
		sendingNewslettersOnBehalfOfUsers: new FormControl(false, []),
	});

	ngOnInit(): void {
		this.subs.sink = this.fromFreezeBlock$.pipe(first((blocked) => blocked !== null)).subscribe((blocked) => {
			this.form.get('blocked').patchValue(blocked, { emitEvents: false });
		});
		this.subs.sink = this.hasUserPermission$
			.pipe(first((userHasWriteAccessPermission) => userHasWriteAccessPermission !== null))
			.subscribe((userHasWriteAccessPermission) => {
				this.form.get('userHasWriteAccessPermission').patchValue(userHasWriteAccessPermission, { emitEvents: false });
			});
		this.subs.sink = this.sendingNewslettersOnBehalfOfUsers$
			.pipe(first((sendingNewslettersOnBehalfOfUsers) => sendingNewslettersOnBehalfOfUsers !== null))
			.subscribe((sendingNewslettersOnBehalfOfUsers) => {
				console.log('sendingNewslettersOnBehalfOfUsers', sendingNewslettersOnBehalfOfUsers);
				this.form
					.get('sendingNewslettersOnBehalfOfUsers')
					.patchValue(sendingNewslettersOnBehalfOfUsers, { emitEvents: false });
			});

		this.subs.sink = this.form.valueChanges.subscribe((value) => {
			this.store$.dispatch(
				fromFreezeBlock.setUserHasWriteAccessPermission({
					userHasWriteAccessPermission: value.userHasWriteAccessPermission,
				})
			);
			this.store$.dispatch(fromFreezeBlock.setFreezeBlocked({ blocked: value.blocked }));
			this.store$.dispatch(
				fromUser.setSendingNewslettersOnBehalfOfUsers({
					sendingNewslettersOnBehalfOfUsers: value.sendingNewslettersOnBehalfOfUsers,
				})
			);
		});

		this.subs.sink = this.hiddenBlocks$.subscribe((hiddenBlocks) => {
			this.hiddenBlocks = hiddenBlocks || [];
		});
	}

	onToggleBlockType(blockType: BlockTypes, hiddenBlocks: string[]): void {
		const isHidden = hiddenBlocks.includes(blockType);
		const updated = isHidden ? hiddenBlocks.filter((b) => b !== blockType) : [...hiddenBlocks, blockType];
		this.store$.dispatch(fromFreezeBlock.setHiddenContentBlocks({ newsletterContentBlocksHidden: updated }));
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	constructor(
		private nbAuth: NewsboardAuthService,
		private store$: Store<fromUser.State>
	) {}
}
